import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Profile from "../views/Profile.vue";
import Devices from "../views/Devices.vue";
import DeviceInfo from "../views/DeviceInfo.vue";
import { authGuard } from "../auth/authGuard";

import About from "../views/About.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    beforeEnter: authGuard
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    beforeEnter: authGuard
  },
  {
    path: "/devices",
    name: "devices",
    component: Devices,
    beforeEnter: authGuard
  },
  {
    path: "/deviceinfo/:deviceid",
    name: "deviceinfo",
    component: DeviceInfo,
    beforeEnter: authGuard,
    props: true
  }         
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
